import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { ChangeEmailComponent } from '../change-email/change-email.component';
import { RouterExtService } from 'src/app/common/services/router-ext.service';
import { Router } from '@angular/router';

import { UploadProgressComponent } from 'src/app/shared/components/upload-progress/upload-progress.component';

@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.css']
})
export class MyProfileComponent implements OnInit {
  profileForm: FormGroup;
  separateDialCode = false;
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;
  onlyCountries = [];
  loadView: boolean = false;
  selectedISOCountry;
  vendorTypes = [];
  vendorTypeRequired: boolean = false;
  propertyImages = [];
  awsFile: FileList;
  constructor(
    private fb: FormBuilder,
    private lookupModel: RsbLookupModel,
    private rsbService: RsbService,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private routerExtService: RouterExtService,
    private router: Router
  ) {
    console.log("profile")
  }

  ngOnInit(): void {
    console.log("profile")
    const profile = this.lookupModel.getLoggedUserPersonalDetails();
    const profileDetails = this.lookupModel.getLoggedUser();
    this.propertyImages.push(profileDetails.personalDetails.profilePic);
    this.profileForm = this.fb.group({
      firstName: [profile ? profile.firstName : '', [Validators.required]],
      lastName: [profile ? profile.lastName : ''],
      email: [profile ? profile.email : '', [Validators.required, Validators.email]],
      mobile: [profile ? profile.mobile : '', [Validators.required]],
      vendorTypeId: [profileDetails ? profileDetails.vendorTypeId : ''],
      aboutMe: [profile ? profile.aboutMe : '']
    });

    this.loadVendorTypes();
    const localCountrys = this.lookupModel.getCountryList();
    this.onlyCountries = [];
    localCountrys.forEach(country => {
      let isoCountry = this.findCountryIso(country.twoDigitCountryCode);
      if (isoCountry) {
        this.onlyCountries.push(isoCountry);
      }
    });

    if (profile.twoDigitCountryCode) {
      this.selectedISOCountry = this.findCountryIso(profile.twoDigitCountryCode);
    } else if (this.lookupModel.getCountry()) {
      this.selectedISOCountry = this.findCountryIso(this.lookupModel.getCountry().twoDigitCountryCode);
    }

    if (this.lookupModel.getRedirection() === 'postproperty') {
      this.vendorTypeRequired = true;
      this.vendorTypeId.setValidators(Validators.required);
      this.profileForm.updateValueAndValidity();
    }

    this.mobile.disable();
    if (profile.email) {
      this.email.disable();
    }
  }

  ngOnDestroy() {
    this.lookupModel.setRedirection('abc');
  }

  loadVendorTypes(): void {
    this.rsbService.getActiveVendorTypes().subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        this.vendorTypes = rsp.contents;
      }
    });
  }



  uploadAws(event: any, fieldName?: string): void {
    this.awsFile = event.target.files;
    const file = this.awsFile.item(0);
    const modalRef = this.modalService.open(UploadProgressComponent, { windowClass: 'signInForm' });
    modalRef.componentInstance.file = file;
    modalRef.result.then((path: any) => {
      if (path) {
        alert(JSON.stringify(path))
        this.propertyImages = [path?.image]
      }

    });
  }

  findCountryIso(countryCode: string): string {
    let isoKey = Object.keys(CountryISO).find(item => CountryISO[item] === countryCode.toLowerCase());
    if (isoKey) {
      return CountryISO[isoKey];
    } else {
      return '';
    }
  }

  update(): void {
    if (this.profileForm.invalid) {
      return;
    }
    console.log(this.profileForm.value);
    const profile = this.lookupModel.getLoggedUserPersonalDetails();
    const args = {
      ...profile,
      firstName: this.firstName.value,
      lastName: this.lastName.value,
      email: this.email.value,
      profilePic: this.propertyImages
    };
    this.rsbService.updateProfile(args).subscribe((rsp) => {
      if (rsp.statusCode === 0) {
        let user = rsp.contents[0];
        this.lookupModel.setLoggedUser(user);
        this.toastrService.success('Profile updated successfully.');
        const previousUrl = this.lookupModel.getRedirection();
        switch (previousUrl) {
          case 'wishlist':
            this.lookupModel.setRedirection('abc');
            this.router.navigate(['wishlist']);
            break;
          case 'contact-info':
            this.lookupModel.setRedirection('abc');
            this.router.navigate(['contact-info']);
            break;
          case 'postproperty':
            this.lookupModel.setRedirection('abc');
            this.router.navigate(['post-property', 'new']);
            break;
          default:
            this.router.navigate(['']);
            break;
        }
      }
    });
  }

  // editEmail(): void {
  //   const mdlRef = this.modalService.open(ChangeEmailComponent, { centered: true, windowClass: 'loginpop' });
  //   mdlRef.componentInstance.emailAddress = this.email.value;
  //   mdlRef.result.then((rsp) => {
  //     if (rsp) {
  //       this.email.setValue(rsp);
  //     }
  //   });
  // }

  get firstName() { return this.profileForm.get('firstName'); }
  get lastName() { return this.profileForm.get('lastName'); }
  get email() { return this.profileForm.get('email'); }
  get mobile() { return this.profileForm.get('mobile'); }
  get aboutMe() { return this.profileForm.get('aboutMe'); }
  get vendorTypeId() { return this.profileForm.get('vendorTypeId') }
}
